import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const useCloseOnLeave = (closeCb: () => void) => {
  const location = useLocation()

  useEffect(() => {
    closeCb()
  }, [location.key])
}
